/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Wave41IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Wave41Icon(props: Wave41IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 715 159"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "m0 95.4 19.861-5.317c19.861-5.117 59.583-16.049 99.306-21.166 39.722-5.317 79.444-5.317 119.166 2.633C278.056 79.5 317.778 95.4 357.5 95.4s79.444-15.9 119.167-18.533c39.722-2.833 79.444 8.099 119.166 7.95 39.723.149 79.445-10.783 99.306-15.9L715 63.6V159H0z"
        }
      ></path>
    </svg>
  );
}

export default Wave41Icon;
/* prettier-ignore-end */
